import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as ClassicEditor from 'src/assets/js/ck-editor/ckeditor.js';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';
import { VerifyCloseComponent } from '../verify-close/verify-close.component';

export interface DialogData {
  title: string;
  date: string;
  description: string;
}

@Component({
  selector: 'app-agenda-event-dialog',
  templateUrl: './agenda-event-dialog.component.html',
  styleUrls: ['./agenda-event-dialog.component.css']
})
export class AgendaEventDialogComponent implements OnInit {

  public editor = ClassicEditor;
  @ViewChild('weekEventDetailsDialogMenuTitle') weekEventDetailsDialogMenuTitle: ElementRef;
  public editorConfig = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      'blockQuote'
    ]
  };

  UpdateWeekEventData = {
    title: '',
    descritption: ''
  };

  constructor(
    public eventDialog: MatDialogRef<AgendaEventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog) { }

  ngOnInit(): void {}

  editorTitleChange(){
    this.UpdateWeekEventData.title = this.weekEventDetailsDialogMenuTitle.nativeElement.innerHTML;
  }

  editorContentChange({ editor }: ChangeEvent ) {
    this.UpdateWeekEventData.descritption = editor.getData();
  }

  closeDialog() { this.eventDialog.close(); }
  deleteEvent() {
    const eventDeleteDialog = this.dialog.open(VerifyCloseComponent);
    eventDeleteDialog.afterClosed().subscribe(result => {
      if (result) {
        this.closeDialog();
      }
    });
  }

  getUpdatedWeekEventData() {
    return {
      title: (this.UpdateWeekEventData.title === '') ? this.data.title : this.UpdateWeekEventData.title,
      description: this.data.description
    };
  }
}
